module.exports = __webpack_public_path__ + "img/shopbase-five-en.733d9747.png";